const config = {
  API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL ||
    'https://pemwebapi.sqm-vitas.com.br/api',
  DB_NAME: process.env.REACT_APP_DB_NAME || 'sqmvitas',
  DB_VERSION: process.env.REACT_APP_DB_VERSION || '1',
};

export default config;
